import { render, staticRenderFns } from "./Ranktile.vue?vue&type=template&id=598bb51c&scoped=true&"
import script from "./Ranktile.vue?vue&type=script&lang=js&"
export * from "./Ranktile.vue?vue&type=script&lang=js&"
import style0 from "./Ranktile.vue?vue&type=style&index=0&id=598bb51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598bb51c",
  null
  
)

export default component.exports